import { render } from "./Groups.vue?vue&type=template&id=35008e8d&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=35008e8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35008e8d"]])

export default __exports__